import { NavLink } from 'react-router-dom'
import { FilterMatchMode } from 'primereact/api'
import { ButtonGroup } from 'react-bootstrap'
import { useState } from 'react'
import DeleteDialog from '../../../common/dialogs/DeleteDialog'
import PageHeader from '../../../layout/page/PageHeader'
import DataTable from '../../../common/data-table/DataTable'
import { useAppSelector } from '../../../../store/hooks'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit } from '@fortawesome/free-solid-svg-icons'

type TableRow = Record<string, unknown> & { id?: number; full_name?: string; media_store_id?: number; pages_name?: string }

const Users = () => {
    const theme = useAppSelector((state) => state.theme.theme)
    const [refreshTable, setRefreshTable] = useState(false)

    const actionsBodyTemplate = (rowData: TableRow) => {
        return (
            <ButtonGroup size="sm">
                <DeleteDialog
                    url={'/administration/users/delete/' + rowData.id}
                    record={rowData}
                    deletedCallback={() => setRefreshTable(true)}
                    message={
                        <p className="mb-3 pb-3 border-bottom">
                            Are you sure you want to delete user{' '}
                            <strong> {rowData.full_name || rowData.id}</strong>?
                        </p>
                    }
                />
                <NavLink
                    to={'/administration/users/view/' + rowData.id}
                    className="btn btn-outline-primary ms-1"
                >
                    <FontAwesomeIcon icon={faEdit} />
                </NavLink>
            </ButtonGroup>
        )
    }

    const imageBodyTemplate = (rowData: TableRow) => {
        return (
            <>
                {rowData.media_store_id ? (
                    <img
                        src={`${process.env.REACT_APP_API_ROOT_URL}/media/download/${rowData.media_store_id}/42`}
                        alt={rowData.pages_name}
                        className="w-6rem shadow-2 border-round"
                        style={{ maxWidth: 42 }}
                    />
                ) : (
                    <div>
                        <FontAwesomeIcon
                            icon={['far', 'image']}
                            className="text-muted fa-2x"
                        />
                    </div>
                )}
            </>
        )
    }

    return (
        <>
            <PageHeader
                icon="users-cog"
                subtitle="Manage user accounts, roles, and permissions"
                gradient="linear-gradient(135deg, #3b82f6, #2563eb)"
                header="Users"
                buttons={[
                    {
                        variant: theme === 'dark' ? 'dark' : 'light',
                        label: 'Back to Administration',
                        icon: 'fa-solid fa-arrow-left',
                        url: '/administration',
                    },
                    {
                        variant: 'success',
                        label: 'Create New',
                        icon: 'fa-solid fa-plus',
                        url: '/administration/users/new',
                    },
                ]}
            />
            <DataTable
                refreshTable={refreshTable}
                onRefreshed={() => setRefreshTable(false)}
                config={{
                    dataRoute: '/administration/users',
                    first: 0,
                    rows: 10,
                    page: 0,
                    sortField: 'full_name',
                    sortOrder: 1,
                    filters: {
                        global: {
                            value: null,
                            matchMode: FilterMatchMode.CONTAINS,
                        },
                        full_name: {
                            value: '',
                            matchMode: FilterMatchMode.CONTAINS,
                        },
                        username: {
                            value: '',
                            matchMode: FilterMatchMode.CONTAINS,
                        },
                        // position: {
                        //     value: '',
                        //     matchMode: FilterMatchMode.CONTAINS,
                        // },
                    },
                    filterDisplay: 'menu',
                }}
                columns={[
                    {
                        field: 'media_store_id',
                        header: 'Image',
                        sortable: true,
                        body: imageBodyTemplate,
                        fixedCenter: true,
                        alignHeader: 'center',
                        headerStyle: {
                            width: '6.5rem',
                            minWidth: '6.5rem',
                            maxWidth: '6.5rem',
                        },
                        style: {
                            width: '6.5rem',
                            minWidth: '6.5rem',
                            maxWidth: '6.5rem',
                        },
                    },
                    {
                        field: 'username',
                        header: 'Username',
                        sortable: true,
                        filter: true,
                        filterPlaceholder: 'Search',
                        fixedCenter: true,
                        alignHeader: 'center',
                        headerStyle: {
                            width: '9.5rem',
                            minWidth: '9.5rem',
                            maxWidth: '9.5rem',
                        },
                        style: {
                            width: '9.5rem',
                            minWidth: '9.5rem',
                            maxWidth: '9.5rem',
                        },
                    },
                    {
                        field: 'full_name',
                        header: 'Full Name',
                        sortable: true,
                        filter: true,
                        filterPlaceholder: 'Search',
                    },
                    // {
                    //     field: 'position',
                    //     header: 'Position',
                    //     sortable: true,
                    //     filter: true,
                    //     filterPlaceholder: 'Search',
                    //     headerStyle: {
                    //         maxWidth: '3rem',
                    //     },
                    //     style: {
                    //         maxWidth: '3rem',
                    //     },
                    // },
                    {
                        field: 'id',
                        header: 'Actions',
                        sortable: false,
                        body: actionsBodyTemplate,
                        alignHeader: 'center',
                        headerStyle: {
                            maxWidth: '1.2rem',
                            textAlign: 'center',
                        },
                        style: {
                            maxWidth: '1.2rem',
                            textAlign: 'center',
                        },
                        toggleVisibility: false,
                    },
                ]}
                globalFilterFields={['username', 'full_name']}
            />
        </>
    )
}

export default Users
